import { atom } from 'recoil';

export const allowedRoutesState = atom({
  key: 'allowedRoutesState',
  default: [],
});
